import { render, staticRenderFns } from "./buy_appeal.vue?vue&type=template&id=2e9190ba&scoped=true"
import script from "./buy_appeal.vue?vue&type=script&lang=js"
export * from "./buy_appeal.vue?vue&type=script&lang=js"
import style0 from "./buy_appeal.vue?vue&type=style&index=0&id=2e9190ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9190ba",
  null
  
)

export default component.exports